module.exports = __webpack_public_path__ + "img/news.3fc65db9.png";